import { useState, type FormEvent } from "react";
import { appConfig } from "../app/config";

interface Props {
  onSubmit: (password: string) => Promise<{ ok: true } | { ok: false; error: string }>;
}

export function LoginScreen({ onSubmit }: Props) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handle(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const result = await onSubmit(password);
    setBusy(false);
    if (!result.ok) setError(result.error);
  }

  return (
    <div className="login-screen" role="dialog" aria-modal="true" aria-labelledby="login-title">
      <div className="login-card">
        <h1 id="login-title" className="login-title">{appConfig.title}</h1>
        <p className="login-subtitle">Bitte gib das Passwort ein, um fortzufahren.</p>
        <form className="login-form" onSubmit={handle} autoComplete="on" noValidate>
          <div className="login-field">
            <label htmlFor="login-password">Passwort</label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
          </div>
          {error && <div className="login-error" role="alert">{error}</div>}
          <button type="submit" className="btn btn-primary login-btn" disabled={busy}>
            {busy ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
